var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 1.63828C6.27773 1.63828 1.63828 6.27773 1.63828 12.0008C1.63828 17.7238 6.27773 22.3633 12.0008 22.3633C17.7238 22.3633 22.3633 17.7238 22.3633 12.0008C22.3633 6.27773 17.7238 1.63828 12.0008 1.63828ZM0.363281 12.0008C0.363281 5.57357 5.57357 0.363281 12.0008 0.363281C18.428 0.363281 23.6383 5.57357 23.6383 12.0008C23.6383 18.428 18.428 23.6383 12.0008 23.6383C5.57357 23.6383 0.363281 18.428 0.363281 12.0008Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 13.6383C11.8006 13.6383 11.6383 13.8006 11.6383 14.0008C11.6383 14.201 11.8006 14.3633 12.0008 14.3633C12.201 14.3633 12.3633 14.201 12.3633 14.0008C12.3633 13.8006 12.201 13.6383 12.0008 13.6383ZM10.3633 14.0008C10.3633 13.0964 11.0964 12.3633 12.0008 12.3633C12.9051 12.3633 13.6383 13.0964 13.6383 14.0008C13.6383 14.9051 12.9051 15.6383 12.0008 15.6383C11.0964 15.6383 10.3633 14.9051 10.3633 14.0008Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62578 11.5133C7.28751 11.5133 7.01328 11.7875 7.01328 12.1258V16.5008C7.01328 16.8391 7.28751 17.1133 7.62578 17.1133H16.3758C16.7141 17.1133 16.9883 16.8391 16.9883 16.5008V12.1258C16.9883 11.7875 16.7141 11.5133 16.3758 11.5133H7.62578ZM5.73828 12.1258C5.73828 11.0833 6.58334 10.2383 7.62578 10.2383H16.3758C17.4182 10.2383 18.2633 11.0833 18.2633 12.1258V16.5008C18.2633 17.5432 17.4182 18.3883 16.3758 18.3883H7.62578C6.58334 18.3883 5.73828 17.5432 5.73828 16.5008V12.1258Z",
    fill: "#146EB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 5.88828C11.3411 5.88828 10.7083 6.15036 10.2419 6.61685C9.77536 7.08335 9.51328 7.71606 9.51328 8.37578V10.8758C9.51328 11.2279 9.22786 11.5133 8.87578 11.5133C8.5237 11.5133 8.23828 11.2279 8.23828 10.8758V8.37578C8.23828 7.3779 8.63469 6.4209 9.34029 5.71529C10.0459 5.00969 11.0029 4.61328 12.0008 4.61328C12.9987 4.61328 13.9557 5.00969 14.6613 5.71529C15.3669 6.4209 15.7633 7.3779 15.7633 8.37578V10.8758C15.7633 11.2279 15.4779 11.5133 15.1258 11.5133C14.7737 11.5133 14.4883 11.2279 14.4883 10.8758V8.37578C14.4883 7.71606 14.2262 7.08335 13.7597 6.61685C13.2932 6.15036 12.6605 5.88828 12.0008 5.88828Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.68487da8e794b38de55a2489d250d83f.svg";
export { ForwardRef as ReactComponent };